export default {
  message: {
    hello: 'Home',
    fee: 'Allow other users to add content for a fee:',
    wasCreated: 'was successfully created',
    displayDelete: 'Are you sure you want to delete this display?',
    campaignDelete: 'Are you sure you want to delete this campaign?',
    newsDelete: 'Are you sure you want to delete this news item?',
    mediaDelete: 'Are you sure you want to delete this media?',
    sourceDelete: 'Are you sure you want to delete this source?',
    teamDelete: 'Are you sure you want to delete this team?',
    teamDeleteConfirm: 'This will delete all items associated with this team (media, campaigns, displays). Please confirm by typing \'DELETE\' below.',
    userDelete: 'Are you sure you want to delete this user?',
    leaveTeam: 'Are you sure you want to leave',
    addTag: 'Type to add tags',
    inUse: 'In use by',
    inUseDelete: 'Unable to delete while in use',
    notUsed: 'This Media item is not used in any Campaigns',
    choose: 'Choose a file',
    drag: 'or drag it here',
    errorAudio: 'Your browser does not support the the audio element',
    noTeam: 'You belong to no teams',
    noDisplay: 'There are no display for this team',
    noCampaigns: 'There are no campaigns for this team',
    noInvoice: 'There are no invoices for you',
    noLogs: 'There are no Logs for you',
    stripeAccept: 'To be able to accept payments from Advertisers you must connect your team to stripe',
    resetPassword: 'To reset your password please enter your email below.',
    resetPasswordDo: 'Please enter a new password',
    forgotSent: 'If the email address provided was correct you will receive an email with further directions',
    error:'Error',
    success:'Success',
    alert:'Alert',
    paidCancel: 'Are you sure you want to cancel the following booking?',
    paidCancelNote: ' Refunds will not be issued for paid bookings which are cancelled by the booking party. If you intend to replace the campaign in the existing booking, please select the replace button instead.',
    replaceBooking: 'Select the campaign to replace what exists in the booking.',
    replaceNote: 'Replacing the campaign of a paid booking will require the display owner to reapprove changes.',
    replaceShort: 'Replacing a campaign with a shorter one will result in shrinking the booking and less screen time.',
    replaceLong: 'You cannot replace a campaign with a longer one.'

  },
  article: {
    on: 'on',
    displayOffline: 'Display Offline',
    lastConnected: 'Last connected'
  },
  report: {
    display_name: 'Name',
    display_owner: 'Owner',
    display_contact: 'Contact',
    display_resolution: 'Resolution',
    display_block_time: 'Block Time',
    display_size: 'Display Size',
    display_pixel_ratio: 'Aspect Ratio',
    campaign_name: 'Name',
    date_scheduled: 'Scheduled At',
    start_date: 'Start Date',
    end_date: 'End Date',
    start_time_daily: 'Start Daily',
    end_time_daily: 'End Daily',
    expected_total_plays: 'Expected Total Plays',
    expected_current_plays: 'Expected Current Plays',
    total_plays_to_date: 'Total Plays To Date',
    extra_plays: 'Extra Plays',
    current_progress: 'Current Progress',
    total_duration: 'Total Duration',
    expected_duration: 'Expected Duration',
    average_duration: 'Average Duration',
    min_duration: 'Min Duration',
    max_duration: 'Max Duration',
    deviation_margin: 'Deviation Margin',
    efficiency_percent: 'Extra Efficiency',
    minimum_brightness: 'Minimum Brightness',
    maximum_brightness: 'Maximum Brightness',
    average_brightness: 'Average Brightness',
    media_items: 'Media Items',
    media_size: 'Total Media Size',
    media_types: 'Media Types',
    playback_quality: 'Playback Quality',
    playback_rating: 'Playback Rating',
    content_fit: 'Content Fit',
    content_scale: 'Content Scale',
    min_max_width: 'Min/Max Width',
    min_max_height: 'Min/Max Height',
    avg_aspect_ratio: 'Avg. Aspect Ratio',
    buyer_name: 'Buyer',
    buyer_contact: 'Contact',
    total_cost: 'Total Cost',
    actual_cost: 'Actual Cost',
    discount: 'Discount',
    gst: 'GST',
    payout: 'Paid?',
    extra_value: 'Extra Value',
    date: 'Date',
    time: 'Time'
  },
  actions: {
    actions: 'Actions',
    search: 'Search',
    delete: 'Delete',
    deleteNews: 'Delete News item with title: ',
    view: 'View',
    edit: 'Edit',
    coupons: 'Coupons',
    pricing: 'Pricing',
    dashboard: 'Dashboard',
    group: 'Group',
    leave: 'Leave',
    cancel: 'Cancel Booking',
    replace: 'Replace Booking'
  },
  show: {
    show: 'Show',
    hide: 'Hide'
  },
  measurement: {
    centimetres: 'cm',
    seconds: 'seconds'
  },
  countries: {
    aus: 'Australia',
    cn: 'China'
  },
  truth: {
    false: 'false',
    true: 'true'
  },
  approval: {
    pending: 'pending',
    approved: 'approved',
    denied: 'denied'
  },
  brightnessControl: {
    maximum: 'maximum',
    sensor: 'sensor',
    scheduled: 'scheduled'
  },
  privacy: {
    private: 'Private',
    public: 'Public'
  },
  screenType: {
    LCD: 'LCD',
    LEDIndoors: 'LED Indoors',
    LEDOutdoors: 'LED Outdoors'
  },
  currency: {
    currency: 'Currency',
    AUD: 'aud',
    CNY: 'cny',
    fullAud: 'Australia Dollar',
    fullCny: 'Chinese Yuan',
    symbol: '$'
  },
  answers: {
    yes: 'Yes',
    no: 'No'
  },
  fonts: {
    futura: 'futura',
    helvetica: 'helvetica',
    arial: 'arial'
  },
  fontStyle: {
    normal: 'normal',
    italic: 'italic',
    oblique: 'oblique'
  },
  fontWeights: {
    normal: 'normal',
    bold: 'bold',
    bolder: 'bolder',
    lighter: 'lighter'
  },
  common: {
    tags: 'Tags',
    admin: 'Admin',
    name: 'Name',
    description: 'Description',
    dimensions: 'Dimensions',
    information: 'Information',
    approval: 'approval',
    edit: 'Edit',
    team: 'Team',
    changeTeam: 'Change Team', 
    id: 'ID',
    teamId: 'Team ID',
    preview: 'Preview',
    schedule: 'Schedule',
    scheduled: 'Scheduled',
    loading: 'Loading',
    type: 'Type',
    key: 'Key',
    total: 'Total'
  },
  buttons: {
    next: 'Next',
    previous: 'Previous',
    addCampaign: 'Add a Campaign',
    bookCampaign: 'Book Campaign',
    create: 'Create',
    edit: 'Edit',
    delete: 'Delete',
    remove: 'Remove',
    createCoupon: 'Create Coupon',
    save: 'Save',
    saveCampaign: 'Save Campaign',
    back: 'Back',
    schedule: 'Schedule',
    add: 'Add',
    upload: 'Upload',
    addText: 'Add Text',
    update: 'Update',
    addKey: 'Add Key',
    verify: 'Verify',
    sortSize: 'Size',
    sortName: 'Name',
    sortDate: 'Date',
    sortTeam: 'Filter by team',
    resetFilter: 'Reset filter',
    verified: 'Verified',
    paidOnly: 'Paid Only',
    date:'Date',
    name:'Name',
    size:'Size',
    dimensions:'Dimensions',
    all:'All',
    image:'Image',
    video:'video',
    search:'Search',
    setting:'Set',
    pricingCal:'Pricing Calculator',
    paid: 'Paid',
    used: 'Unused Only',
    close: 'Close',
    cancel: 'Cancel'
  },
  // Destructive-action prompts (src/lib/confirm.js)
  confirm: {
    removeMember: {
      title: 'Remove team member',
      message: 'Remove {name} from this team? They will lose access to it.'
    },
    deleteKey: {
      title: 'Delete key',
      message: 'Delete the {name} key from this team?'
    },
    deleteImage: {
      title: 'Delete image',
      message: 'Delete {name} from this display\'s gallery?'
    },
    denyBooking: {
      title: 'Deny booking',
      message: 'Deny {campaign} on {display}? The booking will not run.'
    },
    clearAll: {
      title: 'Clear all bookings',
      message: 'Remove all {bookings} campaign bookings from the {displays} displays that match the current filters? This includes displays on other pages. E2V source bookings are kept.'
    },
    deleteDisplay: {
      title: 'Delete {name}',
      message: 'Are you sure you want to delete this display?'
    }
  },
  restrict: {
    toMine: 'Restrict to mine',
    incPublic: 'Include Public',
    campaigns: 'Restrict Campaign'
  },
  dateTime: {
    sDate: 'Start Date',
    eDate: 'End Date',
    sTime: 'Start Time',
    eTime: 'End Time',
    duration: 'Duration',
    eDay: 'Daily',
    dailyTimes: 'Daily Run Times',
    allDay: 'All Day',
    runDates: 'Run Dates',
    date: 'Date',
    dateSelect: 'Select a Date Range',
    dateRange: 'Date Range',
    weekSkip: 'Skip every: ',
    time: 'time',
    seconds: 'seconds',
    secondsLeft: 'seconds left',
    min5: '5 Minutes',
    min10: '10 Minutes',
    min15: '15 Minutes',
    min30: '30 Minutes'
  },
  map: {
    searchOptions: 'Search Options',
    bookingOptions: 'Booking Options',
    searchResults: 'Search Results',
    preparingDisplays: 'Preparing Displays', 
    displayType: 'Display Type',
    displayDetails: 'Display Details',
    bookingDetails: 'Booking Details',
    costOfBooking: 'Cost of Booking',
    addToCart: 'Add to Cart',
    findDisplays: 'Find Suitable Displays',
    date: 'Date'
  },
  index: {
    dashboard: 'Dashboard',
    scheduling: 'Scheduling',
    displays: 'Displays',
    campaigns: 'Campaigns',
    sources: 'E2V Sources',
    media: 'Media Library',
    teams: 'Teams',
    users: 'Users',
    admin: 'Admin',
    publicteams: 'Public Teams',
    teammgt: 'Team Management',
    usermgt: 'User Management',
    news: 'News',
    displaymgt: 'Displays',
    logging: 'Booking Logs'
  },
  sources: {
    sources: 'Sources',
    source: 'source',
    newSource: 'New Source',
    sourceName: 'Source Name',
    uri: 'URI',
    uriDesc:'URI cannot be modified after creating the Source',
    apiKey: 'API Key',
    apiDesc:'The API Key used for access (if applicable)',
    name:'Name',
    nameDesc:'The name of the E2V Source',
    team:'Team',
    teamDesc:'Team cannot be modified after creating the Source',
    badUrl:'The URL provided is not returning the correct data.',
    goodUrl:'Looks good.',
    editDetail:'Edit Details',
    sourceNamePH:'Your source name',
    status:'Status',
    latency:'Latency (ping)',
    APIVer:'API Version',
    campaign:'Available Campaigns',
    author:'Author',
    campany:'Company',
    email:'Contact Email',
    phone:'Contact Phone',
    update:'updated every 5 seconds',
    current:'Current Status',



  },
  schedule: {
    map: 'Public Booking',
    ipam: 'Private Booking',
    selectCampaign: 'Select a Campaign',
    displayRunning: 'Display Running Time',
    campaignDuration: 'Campaign Duration',
    selectSource:'select source',
    oldest:'Oldest',
    newest:'Newest',
    searchCampaigns:'Search Campaigns:',
    searchDisplay:'Search Display:',
    allTeam:'All Teams',
    selectTeam:'Select team',
    prePage:'Previous Page',
    nexPage:'Next Page',
    active:'Active',
    loading:'Loading',
    ipamTitle:'Private Scheduling (IPAM)',
    lastUpdateText:'Last updated',
    noCampaignFound:'No campaigns or sources found.',
    noDisplayFound:'No displays found.',
    updateUnit:'s ago',
    adminSchedule:'Public scheduling not available from admin accounts',
    source:'Hide E2V Sources'


  },
  dashboard: {
    headers: {
      dashboard: 'Dashboard', 
      welcome: 'Welcome back ',
      twowelcome: ', you last logged in',
      campaigns: 'Campaign',
      displays: 'Displays',
      approval: 'Approval Queue',
      activeTeam:'Active Team',
    },
    campaigns: {
      header: 'Currently Running Campaigns',
      name: 'Campaign',
      display: 'Display',
      teaminfo: 'Team Information',
      belongsto: 'This campaign belongs to team: ',
      lastPlayed: 'Last Played Campaign',
      pause:'Pause/Resume',
      clientUptime:'Client Uptime',
      updateTime:'Updated every 30 seconds',

    },
    displays: {
      header: 'Campaigns on My Displays',
      name: 'Campaign Name',
      display: 'Display Name'
    },
    approval: {
      header: 'Scheduled Campaigns Awaiting Approval',
      name: 'Campaign Name',
      display: 'Display Name',
      start: 'Start',
      end: 'End',
      status: 'Status',
      approve: 'Approve',
      deny: 'Deny',
      advertiser: 'Advertiser'
    },
    current: {
      cancel: "Cancel",
      replace: "Replace",
      variantActions: {
        success: 'Perfect',
        info: 'Slightly Shorter',
        warning: 'Much Shorter',
        danger: 'Unable to Book',
        garbage: 'Error'
      }
    },
    common: {
      restrict: 'Restrict',
      refresh: 'Refresh',
      approvalQueue: 'Approval Queue',
      current: 'Current Bookings',
      network: 'Display Status',
      news: 'News',
      allDisplays: 'All Displays Online',
      online: 'Online',
      passive: 'Passive',
      offline: 'Offline',
      lastUpdated: 'Updated every 10 seconds',
      disconnected: 'Could not connect, please try later',
      loading: 'Loading...',
      support: 'Support',
      noTeamDisplay:'This team does not have any displays.',
    },
    campaignStats: {
      campaigns: 'Campaigns',
      playingCampaigns: 'Playing',
      schedCampaigns: 'Scheduled',
      waitApproval: 'Pending'
    },
    mediaStats: {
      image: 'Image | Images',
      video: 'Video | Videos',
      audio: 'Audio',
      used: 'Space Used'
    },
    links: {
      quickLinks: 'Quick Links',
      liveView: 'Live View',
      upload: 'Upload',
      newCampaign: 'New Campaign',
      newDisplay: 'New Display'
    },
    metrics: {
      displayMetrics: 'Display Metrics'
    }
  },

  ipam: {
    displayFilter: 'Display Filter:',
    campaignFilter: 'Campaign Filter:',
    date: 'Date:',
    show: 'Show:',
    add: 'Add', // IPAM scheduler button
    playing: 'Playing',
    scheduled: 'Scheduled',
    noDisplay: 'We could not find any Campaigns or Displays!'
  },
  news: {
    postedBy: 'Posted by ',
    on: 'on',
    theDate: '2019-04-09',
    newsContent: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
  },
  admin:{
    admin: 'Admin',
    news: 'News',
    newsHere: 'Insert News here',
    title: 'Title:',
    createNews: 'Create news item',
    body: 'News Body'
  },
  displays: {
    newDisplay: 'New Display',
    displays: 'Displays',
    display: 'Display',
    dName: 'Display Name',
    dDescription: 'Display Description',
    dDimenstions: 'Display Dimensions',
    maxTime: 'Max Time Purchasable',
    location: 'Location',
    timezoneCurrency: 'Timezone and Currency',
    locationTime: 'Location and Time',
    brightness: 'Brightness Settings',
    type: 'Type',
    privacy: 'Privacy',
    loop: 'Loop Block Duration (seconds, max 1hr)',
    maxTimePurchasable: 'Maximum Time Purchasable',
    physicalHeight: 'Physical Height',
    physicalWidth: 'Physical Width',
    pixelHeight: 'Pixel Height',
    pixelWidth: 'Pixel Width',
    rotation: 'Screen Rotation',
    screenMobility: 'Screen Mobility',
    mobility: 'Mobility',
    mobile: 'Mobile',
    stationary: 'Stationary',
    longitude: 'Longitude',
    latitude: 'Latitude',
    aLongitude: 'Average Longitude',
    aLatitude: 'Average Latitude',
    timezone: 'Timezone',
    currency: 'Currency',
    brightnessControl: 'Brightness Control',
    brightnessCurve: 'Brightness Curve',
    acid: 'ACID',
    hwid: 'HWID',
    demoMode: 'Demo Mode',
    addTags: 'Type to add tags',
    hardwareId: 'Hardware ID',
    publicUrl: 'Public Display URL',
    count: 'Amount of times each campaign will be viewed',
    hwidErro:'Invalid HWID format',
    public:'Public',
    private:'Private',
    address:'Address',
    byLatLn:'By Longitude and Latitude',
    byAdd:'By Address',
    addImage:'Add new image',
    noImage:"",
    defaultPrice:'Default Price Per Second (cents)',
    fullURL:'Full URL: https: ',
    coordinates: 'Coordinates',
    updateInterval:'Update Interval (seconds):',
    diskUsage:'Disk Usage',
    memoryUsage:'Memory Usage',
    CPULoad:'CPU Load',
    wirelessSignal:'Wireless Signal',




  },
  displayCoupon: {
    new: 'New Coupon',
    code: 'Code',
    expiry: 'Expiry',
    price: 'Price',
    percentage: 'Percentage',
    quantity: 'Quantity',
    couponCode: 'Coupon Code',
    value: 'Value',
    unlimited: 'Unlimited'
  },
  displayPricing: {
    default: 'Default Pricing',
    new: 'New Pricing Schedule',
    pps: 'Price Per Second (cents)',
    pricingSchedule: 'Pricing Schedules',
    priority: 'Priority',
    select: 'Select an Option',
    options: 'Display Pricing Options'
  },
  campaigns: {
    campaigns: 'Campaigns',
    campaign: 'campaign',
    campaignCap: 'Campaign',
    newCampaign: 'New Campaign',
    campaignName: 'Campaign Name',
    position: 'Position',
    width: 'Width',
    height: 'Height',
    created: 'Created',
    size: 'Size',
    frameDuration: 'Frame Duration',
    create: 'Creating ',
    updateTeam: 'Update Team',
    emptyName:'Please give your campaign a name',
    emptyTeam:'Please give the campaign a team',
    campaignTagDesc:'Change the tags of your campaign here',
    teamTagDesc: 'Change the team of your campaign here',
    noTeam:'No Team Selected',
    noCampaigns:'No Campaigns',
    scheduledOn: 'Scheduled On'
  },
  media: {
    media: 'Media',
    create: 'Create or Upload Media',
    fontFamily: 'Font-Family',
    fontSize: 'Font-Size',
    fontStyle: 'Font-Style',
    fontWeight: 'Font-Weight',
    mimeType: 'Mime-Type',
    text: 'Text',
    allTeam:'All Teams'
  },
  user: {
    user: 'User',
    users: 'Users',
    accountActivated: 'Your account has been successfully activated.',
    activationProblem: 'There was a problem activating the account. Please contact support.',
    accountDetails: 'Account Details',
    update: 'Update Account',
    username: 'Username',
    email: 'Email',
    emailVerified: 'Email Verified',
    created: 'Created',
    lastLogin: 'Last Login',
    lastModified: 'Last Modified',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm New Password',
    usernameEmail: 'Username / Email',
    enterPassword: 'Enter Password',
    enterEmail: 'Enter Email'
  },
  register:{
    lgName:'The username that you used to sign up.',
    lgPass:'The password for your account.',
    registerActi:'Your account has been registered but is still pending activation.',
    registerEmail:'You have been registered and an email has been sent to confirm for ',
    registerSuc:'was created',
    registerName:'Username',
    email:'Email',
    password:'Password',
    // Two-step sign-up (Register.vue).
    stepOf: 'Step {step} of {total}',
    accountTitle: 'Create your account',
    accountLead: 'Manage your displays from any device, and book paid campaigns on public screens.',
    usernameHint: 'Used to log in. Letters, numbers, dot, underscore or hyphen.',
    emailHint: 'For account notices and activation.',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    continue: 'Continue',
    checking: 'Checking…',
    haveAccount: 'Already have an account?',
    activateTitle: 'Activate your account',
    activateLead: 'Verify a card to activate your account straight away. It is only used when you book screens owned by other teams.',
    verifyAndCreate: 'Verify card and create account',
    creating: 'Creating your account…',
    skipHint: 'No card? Our team will check and activate your account by hand, to prevent fraud.',
    skip: 'Skip, activate manually',
    rule: {
      length: '12 to 32 characters',
      lengthBytes: 'Too long: some characters count as two or more',
      chars: 'No < " or \' characters',
      personal: 'Does not include your username or email',
      leakIdle: 'Not in a known data leak (checked when you continue)',
      leakChecking: 'Checking known data leaks…',
      leakOk: 'Not found in known data leaks',
      leakFound: 'Found in a data leak: choose a different password',
      leakUnknown: 'Could not check data leaks right now',
    },
    err: {
      usernameRequired: 'Enter a username.',
      usernameChars: 'Use only letters, numbers, dot, underscore or hyphen (no spaces or @).',
      usernameTooLong: 'Too long: 32 bytes at most (Chinese characters count as 3).',
      emailRequired: 'Enter your email address.',
      emailInvalid: 'Enter a valid email address, like name@example.com.',
      emailTooLong: 'This email address is too long.',
      password: 'Choose a password that meets every rule below.',
      leaked: 'This password has appeared in a data leak. Choose a different one.',
      bot: 'Something went wrong creating your account. Please try again.',
    },

  },
  teams: {
    teams: 'Teams',
    newTeam: 'New Team',
    slug: 'Team Slug',
    addUser: 'Add User',
    addUsers: 'Add Users',
    description: 'Description',
    public: 'Public Teams',
    email: 'Team Contact Email'
  },
  permissions: {
    permissions: 'Permissions',
    owner: 'Owner',
    display: 'Display',
    pricing: 'Pricing',
    campaign: 'Campaign',
    media: 'Media',
    invoice: 'Invoice',
    thirdParty: 'Third Party Keys',
    team: 'Team'
  },
  stripe: {
    toConnect: 'Connect with Stripe',
    connected: 'Connected to Stripe'
  },
  invoices: {
    invoices: 'Invoices',
    subtotal: 'Subtotal',
    discount: 'Discount'
  },
  event: {
    log: 'Event Log',
    ip: 'IP Address',
    agent: 'User agent',
    action: 'Action'
  },
  account: {
    my: 'My Account',
    logout: 'Logout',
    login: 'Login',
    loginTitle: 'Login to ' + process.env.VUE_APP_NAME,
    register: 'Register',
    forgotPassword: 'Forgot Password',
    passwordReset: 'Password Reset',
    resetPassword: 'Reset Password',
    backToLogin: 'Back to Login',
    stripeCon:'Connecting your team to Stripe',
  },
  language: {
    language: 'Language',
    languages: 'Languages',
    chinese: 'Chinese',
    english: 'English',
  },
  popover: {
    forever: 'Selecting this box will create a booking that never expires.',
    badHelp: 'This team is not configured for public displays. Users will not be able to purchase time from displays managed by this team.'
  },
  checkout: {
    checkout: 'Checkout',
    dailyPlay:'Daily Playback: All Day',
    daily:'Daily Playback:',

  },
  notifications: {
    noMedia: 'There is no media, please add media before attempting to edit the campaign',
    sourceCreate: 'Source has been created',
    sourceError: 'An error occurred while modifying the Source',
    sourceDelete: 'Source has been deleted',
    sourceDeleteError: 'There was an error deleting the Source',
    sourceUpdate: 'Source has been updated',
    campaignCreateError: 'Something went wrong while trying to create the campaign',
    campaignError: 'Something went wrong while trying to create the campaign',
    campaignSave: 'Campaign has been saved',
    campaignSaveError: 'There was an error saving the campaign',
    campaignDelete: 'You have deleted the campaign',
    campaignDeleteError: 'An error occured while trying to delete your campaign',
    campaignApprove: 'Campaign has been approved',
    campaignApproveError: 'An error occured while trying to approve this campaign',
    campaignDenied: 'Campaign has been denied',
    campaignDeniedError: 'An error occured while trying to deny this campaign',
    campaignBook: 'You have booked a campaign onto a display',
    campaignBookError: 'An error occured while trying to book a campaign onto a display',
    campaignRemove: 'The campaign was removed',
    campaignTeamUpdate: 'Campaign team has been updated',
    campaignRemoveError: 'There was a problem removing this campaign',
    mediaRemove: 'You have successfully removed this media from the campaign',
    mediaRemoveError: 'An error occured while trying to delete this item',
    mediaFetchError: 'An error occured when fetching your media',
    mediaNone: 'There is no media, please add media before attempting to create/edit a campaign',
    mediaDelete: 'Deleted media item',
    mediaDeleteError: 'Unable to delete media item',
    frameRemove: 'An error occured while trying to delete this frame',
    costFetchError: 'An error occured while trying to fetch the cost',
    teamNone: 'You must create or be invited to a team before performing any actions',
    userRemove: 'You have removed this user',
    userRemoveError: 'There was an error removing the user',
    userKick: 'You have kicked',
    userAddError: 'There was an error adding the user to team',
    userFetchError: 'Failed to collect your account information',
    userPermissionUpdate: 'You have saved the team permissions for this user',
    userPermissionUpdateError: 'An error occured updating the user\'s permissions',
    teamUpdate: 'You have updated the details for this team',
    teamLeave: 'You have left the team',
    keyUpdateError: 'An error occured while creating a new key',
    keyRemove: 'The key was succesfully deleted',
    keyFetchError: 'An error occured when fetching the team\'s keys',
    stripeConnect: 'Your team has successfully connected to stripe',
    stripeConnectError: 'An error occured while trying to connect your team to stripe',
    stripeUserError: 'An error occured while authenticating you with the team',
    tagRemove: 'removed from campaign',
    tagAdded: 'added to campaign',
    tagLengthError: 'The length of one of the tags is greater than 255 characters, please shorten the tag\'s length',
    displayFetchError: 'An error occured fetching the displays',
    displayDelete: 'You have deleted the display',
    newsDelete: 'You have deleted the news item',
    displayDeleteError: 'An error occured while trying to delete your display',
    newsDeleteError: 'An error occured while trying to delete this news item',
    displayTagRemove: 'has been removed from this display',
    displayTagRemoveError: 'An error occured while trying to remove the tag',
    displayTagAdd: 'has been added from this display',
    displayTagAddError: 'An error occured while trying to add the tag',
    displayUpdate: 'The display has successfully been updated',
    displayUpdateError: 'There was a problem updating the display',
    displayTeamMissing: 'You are required to have a team to create a display',
    displayPricingDefaultError: 'There was an adding a default pricing schedule, you must create one before others can use your display',
    couponExists: 'This code already exists, please use a different code',
    couponDelete: 'You have deleted this coupon',
    couponDeleteError: 'Something went wrong deleting this coupon',
    pricingDefaultUpdate: 'The Default pricing schedule has been updated',
    pricingScheduleCreate: 'A new pricing schedule has successfully been created',
    pricingScheduleCreateError: 'There was a problem creating the pricing schedule',
    pricingScheduleUpdate: 'The pricing schedules have been successfully updated',
    pricingScheduleUpdateError: 'There was a problem updating the pricing schedules',
    messageSaveError: 'There was a problem saving the messages',
    accountActivateError: 'There was an error activating this account',
    accountUpdate: 'Your Account has succesfully been updated',
    invalidFileFormat: 'is a invalid file format',
    cartAdd: 'Added to cart',
    cartAddError: 'Can not add multiples of the same booking',
    teamRemove: 'You have removed this team from the database',
    teamremoveError: 'An error occured while trying to delete this team from the database',
    teamDisplayNone: 'No displays available for this team',
    teamNotExist: 'This team does not exist',
    accountActivated: 'The user account has been activated',
    passwordSuccess: 'Your password has been updated',
    passwordFailure: 'There was an issue updating your password',
  },
    tutorial:{ // flavour text
      sources: 'E2V Sources are for automating your screen contents. If you have an E2V-compatible endpoint, you can add it here.',
      teamExample: 'Teams are where content, bookings and displays are stored. Membership in a team is required to use ' + process.env.VUE_APP_NAME + '.',
      dashboardExample: 'To see the network pane, you must have displays',  // tutorial to go through the entire process on youtube, try to make vue display this only if it is not visible.
      schedulingExample: 'IPAM (Internet Periodic Advertising Matrix) is used to book campaigns privately. Playback status can be affected by network conditions.',
      displaysExample: 'Displays owned by your teams are visible here. You can change display settings, pricing schedules, and coupons here. If the display is online changes made will immediately take effect.',
      newDisplayExample: 'Please enter the display hardware ID. This will be visible when you power on your Adverclient for the first time. If this is not visible, please contact us for assistance', //(screenshot of hardware id screen to be added) 
      newDisplayWarning: 'Note: The display must be approved before you can start using it. Please contact us if this takes more than 24 hours.',
      campaignsExample: 'View and edit your campaigns here. Campaigns which are paid bookings cannot be modified.',
      mediaExample: 'Media uploaded here will be automatically optimised. Please upload media which is under double the resolution of your display, or image quality may be effected.',
      acceptedFileFormats: 'All common file formats for image and video are accepted.',
      publicteamsExample: '', //visible but not sure if necessary??
      teammanagementExample: '', //""
      usermanagementExample: 'Approve users and edit their details here.', //""
      loggingExample: 'Metrics and records of your current and previous bookings are provided here. Data retention is only assured for two weeks after booking completion. Be sure to export records where further retention is required.'
  },
  home:{
    heroHeader: 'Billboard Advertising made affordable in your city',
    heroText: 'Grow your business with advertising on digital billboards anywhere, on a budget with ' + process.env.VUE_APP_NAME + '’s network of digital advertising screens.',
    mapHeader: process.env.VUE_APP_NAME + ' Billboard Locations',
    mapText: 'Amplify your marketing with a DOOH campaign on an ' + process.env.VUE_APP_NAME + ' enabled digital billboard within your budget, in your city.',
    mapRed: 'Zoom out',
    mapCaption: ' to view advertising billboards outside of your city.',
    stepHeader: 'How ' + process.env.VUE_APP_NAME + ' Works',
    step1Header: 'Choose your billboard locations',
    step1Text: 'Use the interactive ' + process.env.VUE_APP_NAME + ' map to pick the display(s) that you want to advertise in your city, or anywhere in the world.',
    step2Header: 'Set your budget & schedule',
    step2Text: 'Set your advertising budget and schedule for your advertising campaign.',
    step3Header: 'Upload your artwork',
    step3Text: 'Upload your artwork and create a campaign that you have made to fit your desired displays. Your artwork will be stored on your ' + process.env.VUE_APP_NAME + ' cloud account to use again in the future.',
    step4Header: 'Wait for approval',
    step4Text: 'Your campaign will be sent to the display owner for approval. ' + process.env.VUE_APP_NAME + ' allows you to track ad plays with a downloadable report so that you can manage your marketing.',
    barHeader: 'Start your free account today',
    barText: 'Ready to amplify your advertising? Start your free ' + process.env.VUE_APP_NAME + ' account today.',
    ownerHeader: 'Own a Digital Display?',
    ownerText: process.env.VUE_APP_NAME + ' is a turnkey cloud solution. Whether your digital signage is LED, LCD, or a custom design; we have a compatible adverclient for you.',
    signUp: 'Sign Up',
    footer: {
      contact: 'Contact Us',
      support: 'Support',
      owners: 'Display Owners',
      tos: 'Terms of Service',
      privacy: 'Privacy Policy',
      ip: 'Intellectual Property'
    }

  },

    
  }



